/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Paymarket } from './Paymarket';
import type { Plan } from './Plan';
import type { SurveyDataCut } from './SurveyDataCut';
import type { SurveyDownloadStatus } from './SurveyDownloadStatus';
import type { SurveyJobProfile } from './SurveyJobProfile';
import type { SurveyModule } from './SurveyModule';
import type { SurveyReplacement } from './SurveyReplacement';
import type { SurveyStatus } from './SurveyStatus';
import type { SurveyVendor } from './SurveyVendor';
import type { VendorFieldMappingProfile } from './VendorFieldMappingProfile';

export type Survey = {
    id: string;
    code?: string;
    name: string;
    files?: Array<Record<string, any>> | null;
    surveyVendorId: string;
    surveyVendor?: (SurveyVendor | Record<string, any> | null);
    surveyJobProfile?: (SurveyJobProfile | Record<string, any> | null);
    surveyModuleId?: string | null;
    surveyModule?: (SurveyModule | Record<string, any> | null);
    SurveyDataCuts?: Array<SurveyDataCut> | null;
    plans?: Array<Plan> | null;
    paymarkets?: Array<Paymarket> | null;
    surveyJobProfileId: string;
    participationId?: string | null;
    version?: string | null;
    public?: boolean;
    effectiveDate?: string | null;
    status?: SurveyStatus;
    isLoaded?: boolean;
    inProgress?: boolean;
    isDetached?: boolean;
    reprocessable?: boolean;
    reprocessRequested?: boolean;
    isClone?: boolean;
    syncEnabled?: boolean;
    createdBy?: string | null;
    vendorFieldMappingProfileId?: string | null;
    vendorFieldMappingProfile?: (VendorFieldMappingProfile | Record<string, any> | null);
    createdAt?: string;
    updatedAt?: string | null;
    surveyJobsMappedPct?: number | null;
    surveyDataCutsUsedPct?: number | null;
    surveyDataCutNameCount?: number | null;
    downloadReportStatus?: SurveyDownloadStatus | null;
    displayLoadStatus?: Survey.displayLoadStatus;
    surveyReplacements?: Array<SurveyReplacement>;
    publishedSurveyReplacements?: Array<SurveyReplacement>;
    currency?: Array<{
        id: string;
    }>;
};

export namespace Survey {

    export enum displayLoadStatus {
        EMPTY = 'EMPTY',
        IN_PROGRESS = 'IN_PROGRESS',
        LOADED = 'LOADED',
        UNDER_REVIEW = 'UNDER_REVIEW',
        AWAITING_VENDOR = 'AWAITING_VENDOR',
        FILE_RECEIVED = 'FILE_RECEIVED',
        LOAD_FAILED = 'LOAD_FAILED',
    }


}

